module.exports = __webpack_public_path__ + "static/media/add-slot-language.c4d50532.png";